import { Navigate, Outlet } from 'react-router-dom';
import { useAuth, ADMIN_ROLES } from '../../contexts/AuthContext';

export const AdminProtectedRoute = () => {
  const { user, role, loading, roleLoading } = useAuth();

  if (loading || roleLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#14141F]" style={{ fontFamily: "'Outfit', sans-serif" }}>
        <div className="flex flex-col items-center gap-3">
          <i className="ri-loader-4-line text-3xl text-violet-500 animate-spin" />
          <span className="text-sm text-white/40">Verificando permissões...</span>
        </div>
      </div>
    );
  }

  if (!user) {
    console.log('[AdminProtectedRoute] sem usuário autenticado, redirecionando para /');
    return <Navigate to="/" replace />;
  }

  if (!role || !ADMIN_ROLES.includes(role)) {
    console.log('[AdminProtectedRoute] role:', role, '— acesso negado, redirecionando para /dashboard');
    return <Navigate to="/dashboard" replace />;
  }

  console.log('[AdminProtectedRoute] papel admin confirmado:', role, '— liberando acesso');
  return <Outlet />;
};
